<div class="login-wrapper">
    <div>
        <div class="wave"></div>
        <div class="wave"></div>
        <div class="wave"></div>
    </div>
    <div class="login-box">
        <div class="logo">
            <img src="assets/Logo-Biotechsa.png" alt="BrightID" />
        </div>

        <h2>Iniciar Sesión</h2>

        <form [formGroup]="formLogin" (ngSubmit)="onSubmit()">
            <div class="p-field">
                <label for="email">Correo Electronico</label>
                <input pInputText id="email" formControlName="email" placeholder="Ingrese su correo"
                    class="password-input" />
                <small style="color: red;" *ngIf="f['email'].touched && f['email'].invalid">
                    <span *ngIf="f['email'].hasError('required')">Campo requerido</span>
                    <span *ngIf="f['email'].hasError('email')">Formato no valido</span>
                </small>
            </div>

            <div class="p-field">
                <label for="password">Contraseña</label>
                <p-password inputId="password" formControlName="password" [feedback]="false"
                    inputStyleClass="password-input" placeholder="Ingrese su contrasena" [toggleMask]="true" />
                <small style="color: red;" *ngIf="f['password'].touched && f['password'].invalid">
                    <span *ngIf="f['password'].hasError('required')">Campo requerido</span>
                </small>
            </div>

            <button pButton type="submit" label="Login" class="login-btn"></button>


            <div class="privacy-policy">
                <a [routerLink]="['/registrar']">Registrar</a>
            </div>
        </form>
    </div>
</div>
<p-toast></p-toast>